module.exports = __webpack_public_path__ + "static/media/icon_6.b6ba4f6f.svg";